module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0122.jpg?v=7a32f6a4";